Ext.define('SA.AppController', {
    extend: 'Ext.util.Observable',

    singleton: true,

    initialize() {
        this.state = new SA.AppControllerState(new SA.AppControllerStateValue({controller: null, mode: null}));
        this.sessionController = new SA.SessionController();

        SA.data.Projects.on('change:viewBuildingBlock', this.onViewBuildingBlockChanged, this);
        SA.data.Projects.on('remove:view', this.onViewRemoved, this);

        this.state.onChangeController(this.onStateControllerChange, this);
        this.state.onChangeMode(this.onStateModeChange, this);

        window.addEventListener('unhandledrejection', this.onUnhandledRejection.bind(this));
    },

    deleteProject(project) {
        SA.data.Projects.delete(project);

        SA.LocationsReferenceTracker.purgeUnreferencedFromCache();

        this.openLastViewedOrNewProject();
    },

    deleteView(viewModel) {
        var project = viewModel.getProject();

        project.removeView(viewModel);
        project.save();
    },

    editView(model) {
        this.showProjectView(model, 'edit');
    },

    getCurrentController() {
        return this.state.getController();
    },

    getCurrentCountry() {
        return SA.Institution.getCountry(this.getCurrentCountryCode());
    },

    getCurrentCountryCode() {
        return this.getCurrentModel().getCountry();
    },

    getCurrentModel() {
        return this.getCurrentController().getModel();
    },

    getCurrentModelCensusRelease() {
        return this.getCurrentModel().getCensusRelease();
    },

    getCurrentProject() {
        return this.getCurrentModel().getProject();
    },

    isActiveController(controller) {
        return this.getCurrentController() === controller;
    },

    isCurrentModel(model) {
        return this.getCurrentModel() === model;
    },

    onStateControllerChange({lastController, controller, lastMode, mode}) {
        Ext.suspendLayouts();

        lastController?.setModeActive?.(lastMode, false);
        lastController?.deactivate?.();
        lastController?.onInactive?.();
        controller.onActive?.(mode);
        controller.activate?.(mode);
        controller.setModeActive?.(mode, true);

        Ext.resumeLayouts(true);

        this.getCurrentProject().refreshViewedTime();

        this.fireEvent('switch:projectView');
    },

    onStateModeChange({controller, lastMode, mode}) {
        Ext.suspendLayouts();

        controller.setModeActive?.(lastMode, false);
        controller.setModeActive?.(mode, true);
        controller.switchMode?.();

        Ext.resumeLayouts(true);

        this.fireEvent('switch:projectView');
    },

    onUnexpectedAjaxError(error) {
        if (error.isSessionError()) {
            this.sessionController.onAjaxSessionError(error);
            return;
        }

        SA.ErrorStack.show(error);
    },

    onUnhandledRejection(error) {
        if (!SA.AjaxError.hasInstance(error.reason)) {
            SA.ErrorStack.show('An unexpected error occurred.');
        }
    },

    onViewBuildingBlockChanged(viewModel) {
        var switchToEditMode = this.isCurrentModel(viewModel) && this.state.isViewMode() && !viewModel.isViewable();

        if (switchToEditMode) {
            this.showProjectView(viewModel, 'edit');
        }
    },

    onViewRemoved(viewModel) {
        if (this.isCurrentModel(viewModel)) {
            this.openProject(viewModel.getProject());
        }
    },

    openLastViewedOrNewProject() {
        var project = SA.data.Projects.getLastViewed();

        if (!project) {
            project = SA.data.Projects.createEmpty();

            Ext.createByAlias('controller.new-project-controller', {project});
        }

        this.openProject(project);
    },

    openProject(project) {
        var firstView = project.getViews()[0];

        if (firstView) {
            this.showProjectView(firstView);
        }
        else {
            this.showProjectView(project, 'edit');
        }
    },

    sessionReplacedOrExpired() {
        return this.sessionController?.replacedOrExpired();
    },

    showProjectView(model, requestedMode = 'view') {
        var stateValue = new SA.AppControllerStateValue({
            controller: model.getController(),
            mode: model.isViewable() ? requestedMode : 'edit'
        });

        this.state.set(stateValue);
    }
});
